export default __webpack_public_path__ + "media/images/Masto-C1-JournéeDlaFemme-bff97fd6c433243a98832de3552b1d88.png";